import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="flex items-center flex-wrap gap-1.5 text-sm text-muted-foreground">
      <Link to="/" className="hover:text-foreground transition-colors inline-flex items-center gap-1"><Home className="h-3.5 w-3.5" /></Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <ChevronRight className="h-3.5 w-3.5 opacity-60" />
          {it.to ? (
            <Link to={it.to} className="hover:text-foreground transition-colors">{it.label}</Link>
          ) : (
            <span className="text-foreground font-medium truncate max-w-[220px]">{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
